type AuthApiResolveOptions = {
    host?: string | null;
    origin?: string | null;
};

const productionHosts = new Set(['kromatic.com', 'www.kromatic.com']);

function normalizeHost(rawValue: string | null | undefined): string | null {
    if (!rawValue) {
        return null;
    }

    const normalized = rawValue
        .split(',')[0]
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .split('/')[0]
        .split(':')[0];

    return normalized || null;
}

function resolveKnownHostApiBaseUrl(host: string | null): string | null {
    if (!host) {
        return null;
    }

    if (host === 'staging.kromatic.com') {
        return 'https://staging-api.kromatic.com';
    }

    if (productionHosts.has(host)) {
        return 'https://api.kromatic.com';
    }

    return null;
}

export function resolveAuthApiBaseUrl(
    configuredValue: string | undefined,
    options: AuthApiResolveOptions = {}
): string | null {
    const host = normalizeHost(options.host);
    const knownHostApiBaseUrl = resolveKnownHostApiBaseUrl(host);
    const configured = (configuredValue || '').trim();

    if (!configured) {
        return knownHostApiBaseUrl;
    }

    if (/^https?:\/\//i.test(configured)) {
        try {
            const parsed = new URL(configured);
            const configuredHost = parsed.hostname.toLowerCase();
            const configuredPath = parsed.pathname || '';

            if (
                knownHostApiBaseUrl &&
                (configuredHost === 'staging.kromatic.com' || productionHosts.has(configuredHost)) &&
                configuredPath.startsWith('/api')
            ) {
                return knownHostApiBaseUrl;
            }

            return configured.replace(/\/+$/, '');
        } catch {
            return knownHostApiBaseUrl;
        }
    }

    if (configured.startsWith('/')) {
        if (knownHostApiBaseUrl) {
            return knownHostApiBaseUrl;
        }

        const origin = (options.origin || '').trim();
        if (/^https?:\/\//i.test(origin)) {
            return `${origin}${configured}`.replace(/\/+$/, '');
        }

        if (host) {
            return `https://${host}${configured}`.replace(/\/+$/, '');
        }

        return null;
    }

    return knownHostApiBaseUrl;
}
